import { render } from "./FacialHarmonizationContent.vue?vue&type=template&id=49c504ed&scoped=true"
import script from "./FacialHarmonizationContent.vue?vue&type=script&lang=js"
export * from "./FacialHarmonizationContent.vue?vue&type=script&lang=js"

import "./FacialHarmonizationContent.vue?vue&type=style&index=0&id=49c504ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c504ed"]])

export default __exports__